import { handleActions } from 'redux-actions';
import { Contract, ContractId } from 'shared/models';
import { Actions, cacheContractLockState, cacheContracts } from 'actions/contractActions';
import { Actions as SessionActions } from 'actions/sessionActions';
import { deepSet } from 'logic/deepSet';

export type State = Readonly<{
    data: Record<ContractId, Contract>;
}>;

export const initialState = Object.freeze<State>({
    data: {},
});

export const contractsReducer = handleActions({
    [Actions.CACHE_CONTRACTS]: (state: State, { payload }: ReturnType<typeof cacheContracts>) => {
        const { data } = state;
        return {
            ...state,
            data: {
                ...data,
                ...payload,
            },
        };
    },

    [Actions.CACHE_CONTRACT_LOCK_STATE]: (state: State, action: ReturnType<typeof cacheContractLockState>) => {
        const contractId = action.payload;
        return deepSet(state, `data.${contractId}.locked`, action.meta.locked);
    },


    //
    //  Session Actions
    //
    [SessionActions.LOGOUT_SUCCESS]: () => {
        return initialState;
    },
} as any, initialState);
